import script from "./Standard-Text.vue?vue&type=script&setup=true&lang=js"
export * from "./Standard-Text.vue?vue&type=script&setup=true&lang=js"

import "./Standard-Text.vue?vue&type=style&index=0&id=3f6aa7b1&lang=css"

const __exports__ = script;

export default __exports__